import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import * as htmlToImage from 'html-to-image';
import OrderDetailsItem from "../../Components/OrdersComponent/OrderDetailsItem";
import { jsPDF } from "jspdf";
import { useTranslation } from 'react-i18next';
import { toast } from "react-toastify";
import { OverlayLoader } from "../../Components/Shimmers";
import { axiosGet } from "../../Apis/axiosMethods";

const Success = () => {

    const dir = localStorage.getItem('dir');

    const { t } = useTranslation();
    const { order_uid } = useParams();
    const { currency, lang, apiB2BURL, apiHeaderJson } = useContext(ConfigContext);
    const [orderInfo, setOrderInfo] = useState([]);

    const [loading, setLoading] = useState(true)
    const [address, setAddress] = useState([]);
    const [items, setItems] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
    })

    useEffect(() => {
        OrderInfo();
    }, []);

    const OrderInfo = async () => {
        try {
            setLoading(true);

            const response = await axiosGet(`/Orders/GetCurrencyConversionOrdersDetails`,
                {
                    lang: lang,
                    secret_order_id: order_uid,
                    currency
                }
            );

            setOrderInfo(response?.data.data);
            setItems(response?.data.items);
            setAddress(response?.data?.address);

        } catch (error) {
            console.error('Error fetching order info:', error);
        } finally {
            setLoading(false);
        }
    };

    const downloadInvoice = () => {
        htmlToImage.toPng(document.getElementById('myInvoice'))
            .then(async (dataUrl) => {
                downloadPdf(dataUrl);
            });
    };

    const printInvoice = () => {
        const invoiceElement = document.getElementById('myInvoice');
        const computedStyle = window.getComputedStyle(invoiceElement);
        const actualWidth = invoiceElement.offsetWidth;
        const actualHeight = invoiceElement.offsetHeight;

        const options = {
            scale: 2,
            style: {
                transform: 'scale(1)',
                transformOrigin: 'top left',
                margin: '0px',
                backgroundColor: 'white',
            },
            quality: 1.0,
            cacheBust: true
        };

        htmlToImage.toPng(invoiceElement, options)
            .then(async (dataUrl) => {
                const pdf = new jsPDF({
                    orientation: 'p',
                    unit: 'pt',
                    format: 'a4',
                    compress: true
                });

                const imgProps = pdf.getImageProperties(dataUrl);
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

                pdf.addImage(dataUrl, 'PNG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST');

                const title = `Invoice-${order_uid}`;
                const printWindow = window.open(pdf.output('bloburl'), '_blank');
                if (printWindow) {
                    printWindow.document.title = title;
                    printWindow.print();
                }
            })
            .catch(error => {
                console.error('Error generating invoice:', error);
                toast.error('Error generating invoice. Please try again.');
            });
    };

    const downloadPdf = async (base64Image) => {
        const pdf = new jsPDF({
            orientation: 'p',
            unit: 'pt',
            format: 'a4',
            compress: true
        });

        const image = new Image();
        image.src = base64Image;

        image.onload = () => {
            // Get PDF dimensions
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            // Calculate image dimensions while maintaining aspect ratio
            const aspectRatio = image.width / image.height;
            let newWidth = pdfWidth * 0.8; // Use 80% of PDF width
            let newHeight = newWidth / aspectRatio;

            // If height exceeds page height, scale down
            if (newHeight > pdfHeight * 0.8) {
                newHeight = pdfHeight * 0.8;
                newWidth = newHeight * aspectRatio;
            }

            // Calculate margins to center the image
            const xMargin = (pdfWidth - newWidth) / 2;
            const yMargin = (pdfHeight - newHeight) / 2;

            // Add the image to PDF with calculated dimensions and position
            pdf.addImage(base64Image, 'PNG', xMargin, yMargin, newWidth, newHeight, undefined, 'FAST');

            // Save the PDF
            pdf.save(`Invoice-${order_uid}.pdf`);
        };
    };

    const handleMailInvoice = async () => {
        try {

            var config = {
                method: 'post',
                url: `${apiB2BURL}/Customer/Orders/SendMailOrder?order_id=${orderInfo.business_order_id}`,
                headers: apiHeaderJson,
                params: {
                    lang: lang
                }
            };
            const response = await axios(config);

            if (response.data.success) {
                toast.success("Invoice has been sent to your email successfully.");
            } else {
                toast.error("Failed to send invoice. Please try again.");
            }
        } catch (error) {
            console.error("Error sending invoice:", error);
            toast.error(t("error_sending_invoice"));
        }
    };

    return (
        <>
            {
                loading ?
                    <div style={{ height: "70vh" }}>
                        <OverlayLoader />
                    </div>
                    :
                    <main className="main" dir={dir}>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div style={{ marginTop: '10%' }}>
                                        <center>
                                            <p>
                                                <i style={{ fontSize: '80px', color: '#28a745' }} className="sicon-check"></i>
                                            </p>
                                            <h3>{t("thank_you_for_your_order")}</h3>
                                            {orderInfo.business_order_payment_method === 'bank' ? <p>Your order has been accepted and will be shipped as soon as we receive the full payment in our bank account. Our banking details are specified below and have also been sent to {orderInfo.business_email} along with the order details.
                                                Please complete the payment within three business days to expedite the shipment. Otherwise, the ordered items may lose the "Reserved for Shipment" status.</p>
                                                : <p>{t("the_order_confirmation_line")}</p>}
                                            <button className="btn btn-default btn-ellipse btn-md">{t("order_number", { value: ":#" + order_uid })}</button>
                                        </center>
                                        <div className="d-flex justify-content-center" style={{ marginTop: '10px' }}>
                                            <button type="button" onClick={() => downloadInvoice()} className="btn btn-success btn-sm"><i className="sicon-cloud-download"></i></button>
                                            <button type="button" onClick={() => printInvoice()} className="btn btn-primary btn-sm"><i className="sicon-printer"></i></button>
                                            <button onClick={() => handleMailInvoice()} className="btn btn-info btn-sm"><i className="sicon-envelope"></i></button>
                                        </div>
                                        <br />

                                        {orderInfo.business_order_payment_method === 'bank' && <div style={{ color: '#000', backgroundColor: '#f7f7f7', padding: '20px', marginBottom: "20px" }}>
                                            <p><strong>To complete the order, please transfer {orderInfo.grand_total_incl_vat} to our bank account specified below:</strong></p>
                                            <p><strong>Account Name:</strong> GHAYAR AUTO SPARE PARTS TRADING LLC</p>
                                            <p><strong>Bank:</strong> RAK BANK</p>
                                            <p><strong>IBAN:</strong> AE490400000052913125001</p>
                                            <p><strong>SWIFT Code:</strong> NRAKAEAK</p>
                                            <p><strong>E-MAIL ID:</strong> contact@ghayar.ae</p>
                                            <p><strong>Account Number:</strong> 0052913125001 {currency.toUpperCase()}</p>
                                            <p><strong>Account Type:</strong> Current Account {currency.toLowerCase() === "usd" ? "(Dollar)" : "(Dirhams)"} </p>
                                            <p><strong>Total Amount:</strong> {orderInfo.grand_total_incl_vat}</p>
                                            <p><strong>Payment Reference:</strong> {orderInfo.secret_order_id}</p>

                                            <a target="_blank" href={`https://b2bapi.ghayar.com/bakingdetails/${orderInfo.secret_order_id}.pdf`}>
                                                <i className="sicon-cloud-download"></i> Download Banking Details</a>
                                            <br /> <br />
                                            <p> Once the payment is completed, please send the payment confirmation or receipt to business@ghayar.com for verification.
                                                We appreciate your business and look forward to serving you again!
                                                Best Regards,Ghayar B2B Team</p>
                                        </div>}
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div id="myInvoice" className="mt-2">
                                        {/* <Invoice order={orderInfo} items={items} address={address} /> */}
                                        <OrderDetailsItem
                                            order={orderInfo}
                                            items={items}
                                            address={address}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
            }
        </>
    );
};

export default Success;